module.exports = __webpack_public_path__ + "fonts/Open_Sans-600-cyrillic20.11f411e.woff2";